// 意大利语
const it = {
    // 首页-激活说明
    activateExplain: {
        title: 'Attiva la garanzia estesa e ricevi il regalo speciale per te',
        desp: 'Condizioni applicate: per qualificarsi, i clienti accettano di condividere la loro esperienza di acquisto con i nostri prodotti acquistati che utilizzano attivamente da almeno una settimana.',
        conditions: [
            'Solo per i clienti che hanno acquistato i prodotti su Amazon.',
            'Ogni cliente può richiedere un solo REGALO GRATUITO per un prodotto. (Il che significa che non importa quante volte acquisti lo stesso prodotto, puoi ottenere solo un regalo GRATUITO).',
        ]
    },
    // 首页-激活表单
    activateForm: {
        title: 'Attiva la garanzia estesa e ricevi subito il regalo GRATUITO!',
        desp: 'Disponibile solo per i clienti esistenti',
        name: 'Nome',
        namePlaceholder: `Immettere il nome del destinatario`,
        nameErrMsg: `Il nome non è corretto.`,
        email: 'Email',
        emailPlaceholder: `Inserisci la tua email`,
        emailErrMsg: `L'email non è corretta.`,
        verifCode: 'Codice di verifica',
        verifCodePlaceholder: `Inserisci il tuo codice di verifica`,
        verifCodeErrMsg: `Codice di verifica errato.`,
        btnSendCode: `Invia il codice di verifica`,
        countdownMsg: `Invia di nuovo tra {countdown} secondi`,
        orderId: 'ID ordine',
        orderIdPlaceholder: `Inserisci il tuo ID ordine`,
        orderAppliedError: `Questo ordine ha già richiesto un regalo.`,
        orderIdErrMsg: `L'ID ordine non è corretto.`,
        skuAppliedError: `Il regalo di questo ordine è stato ritirato.`,
        orderIdHelp: 'Come trovare il tuo ID ordine?',
        btnAactivate: 'Attivare ora',
        statement: 'Certamente non condivideremo le tue informazioni personali con altri.',
        orderIdErrPopoverMsg: `Se il tuo ID ordine è sicuro, ti preghiamo di contattare il nostro servizio clienti via e-mail. Ti aiuteremo ad attivare la garanzia estesa e a confermare se l'evento copre il tuo mercato.`,
        priceErrPopoverMsg: 'Siamo spiacenti di dirti che questo ordine ha utilizzato il nostro sconto più basso, in caso di problemi, non esitare a contattarci via email.'
    },
    // 通用弹框
    commonModal: {
        msg: `{msg}`,
        msgContents: [
            `Il nome del destinatario non può corrispondere all'ordine`,
            `Se la recensione di Amazon è stata completata?`,
            `Would you like to continue to Amazon to review?`
        ],
        btnRewrite: 'Riscrivere',
        btnNo: 'Desideri continuare ad esaminare Amazon?',
        btnYes: 'SÌ'
    },
    // 选择礼物
    chooseGift: {
        title: 'Ora, scegli il regalo che desideri.',
        modalTitle: 'Siamo spiacenti, il regalo che hai selezionato non è più disponibile, per favore scegli di nuovo',
        btnWant: 'Lo voglio',
        btnStockout: 'Esaurito'
    },
    // 订单信息
    orderInfo: {
        title: 'Complimenti! La tua garanzia estesa è attivata!',
        desp: 'Cosa otterrai',
        orderTitle: 'Informazioni sul tuo ordine',
        orderId: 'ID ordine',
        productASIN: 'Prodotto ASIN',
        productName: 'Titolo del prodotto',
        address: 'Indirizzo',
        aboutGift: [
            'A proposito del regalo',
            'NESSUN costo di spedizione, NESSUN costo nascosto, NESSUNA carta di credito richiesta',
            '4 semplici passaggi per ottenerlo (meno di 5 minuti).',
            'Il regalo verrà inviato entro 2-5 giorni lavorativi dalla data di richiesta.'
        ],
        btnWant: 'Lo voglio'
    },
    // 步骤1
    stepOne: {
        title: `Passaggio 1 di 4: un breve sondaggio sull'acquisto.`,
        questionList: [{
                id: 1,
                select_type: 'radio',
                name: 'sex',
                title: '1. Sono un ...?',
                option: [{
                        txt: 'Femmina',
                        value: 0
                    },
                    {
                        txt: 'Maschio',
                        value: 1
                    },
                    {
                        txt: 'Non sono sicuro',
                        value: 2
                    }
                ]
            },
            {
                id: 2,
                select_type: 'radio',
                name: 'age',
                title: `2. Qual è la tua fascia d'età?`,
                option: [{
                        txt: 'Meno di 20',
                        value: 0
                    },
                    {
                        txt: '20-30',
                        value: 1
                    },
                    {
                        txt: '30-40',
                        value: 2
                    },
                    {
                        txt: '40-50',
                        value: 3
                    },
                    {
                        txt: '50-60',
                        value: 4
                    },
                    {
                        txt: 'Più di 60',
                        value: 5
                    }
                ]
            },
            {
                id: 3,
                select_type: 'radio',
                name: 'reason',
                title: '3. Perché ci hai scelto?',
                option: [{
                        txt: 'Marca',
                        value: 0
                    },
                    {
                        txt: 'Design',
                        value: 1
                    },
                    {
                        txt: 'Prezzo',
                        value: 2
                    },
                    {
                        txt: 'Caratteristiche',
                        value: 3
                    },
                    {
                        txt: 'Recensioni',
                        value: 4
                    },
                    {
                        txt: 'Altri motivi',
                        value: 5,
                        placeholder: 'Per favore, inserisci un motivo'
                    }
                ]
            },
        ],
        btnNext: 'passo successivo'
    },
    // 步骤2
    stepTwo: {
        title: 'Passaggio 2 di 4: raccontaci la tua esperienza sul prodotto.',
        despOne: `Valutazione complessiva?`,
        despTwo: `Facci sapere come funzionano i nostri prodotti per te.`,
        notice: `(Inserire almeno 10 caratteri)`,
        commentPlaceholder: 'Inserisci il tuo commento',
        commentErrMsg: `Le parole dei commenti non possono superare i 20.000`,
        btnNext: 'passo successivo',
        btnPrev: 'passo precedente'
    },
    // 步骤3
    stepThree: {
        title: 'Passaggi 3 di 4: condividi la tua esperienza di acquisto con gli altri.',
        desp: 'Ti bastano pochi secondi. I tuoi commenti aiuterebbero gli altri clienti a prendere una migliore decisione di acquisto. Grazie per la comprensione e il supporto.',
        commentTitle: 'I tuoi commenti',
        defaultComment: 'I like your product very mucMi piace molto il tuo prodotto!h!',
        btnCopyPost: 'Fai clic qui per copiare e pubblicare la tua recensione di amazom'
    },
    // 步骤4
    stepFour: {
        title: 'Passaggio 4 di 4: conferma il tuo indirizzo.',
        desp: 'Cosa otterrai',
        fullName: 'Nome completo',
        fullNamePlaceholder: `Inserisci il tuo nome completo`,
        fullNameErrMsg: `Il nome completo non è corretto`,
        phone: 'Telefono',
        phonePlaceholder: `Inserisci il tuo telefono`,
        phoneErrMsg: `Il telefono non è corretto`,
        email: 'Email',
        emailPlaceholder: `Inserisci la tua email`,
        emailErrMsg: `L'email non è corretta`,
        address: 'Indirizzo',
        addressPlaceholder: `Inserisci il tuo indirizzo`,
        addressErrMsg: `Indirizzo errato`,
        streetPlaceholder:`Indirizzo`,
        apartmentPlaceholder:`Appartamento / Unità`,
        cityPlaceholder:`Città`,
        regionPlaceholder: `Seleziona la regione`,
        countryPlaceholder: `Scegli un paese`,
        postcode: 'Codice postale',
        postcodePlaceholder: `Inserisci il tuo codice postale`,
        postcodeErrMsg: `Il codice postale non è corretto`,
        btnComfirm: 'comfirm'
    },
    // 完成礼物申请
    completeApplication: {
        title: `Hai completato l'applicazione regalo gratuita`,
        msgs: [
            'Il regalo gratuito verrà spedito in 2-5 giorni lavorativi.',
            'Il regalo gratuito verrà inviato alla tua e-mail ',
            ' entro 2-5 giorni lavorativi.Sinceramente grazie per aver acquistato i nostri prodotti, quindi ci sarà un contatto dedicato del team post-vendita.',
            'Eventuali ulteriori problemi che potresti riscontrare, ti preghiamo di contattare il nostro servizio clienti via e-mail o visitare il nostro sito Web ufficiale.',
            'Poiché non sei soddisfatto al 100% dei nostri prodotti, puoi contattare il nostro servizio clienti via e-mail o visitare il nostro sito Web ufficiale, ci saranno professionisti che ti serviranno. La soddisfazione del cliente al 100% è la nostra garanzia!'
        ],
        btnComfirm: 'comfirm'
    },
    // 获取订单号指导
    guide: {
        title: 'Come trovare il tuo ID ordine?',
        desps: [
            `Passaggio 1: Accedi al tuo account Amazon e fai clic su "Il tuo ordine" nella pagina Account ed elenchi`,
            `Passaggio 2: fai clic su "Dettagli ordine" nell'ordine giusto`,
            `Passaggio 3: vedrai il tuo ID ordine`
        ],
        btnOK: 'ok'
    }
}

export default it